import axios from 'axios';

export const liveChatBaseUrl = (
  process.env.REACT_APP_CHAT_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  ''
).replace(/\/$/, '');

export const liveChatWsBaseUrl = liveChatBaseUrl
  .replace(/^https:\/\//, 'wss://')
  .replace(/^http:\/\//, 'ws://');

const liveChatApi = axios.create({
  baseURL: liveChatBaseUrl,
  headers: { 'Content-Type': 'application/json' },
});

liveChatApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default liveChatApi;

